import React from 'react';

import { ReactComponent as AiIcon } from '../../../../assets/icons/trainings/ai.svg';
import AppIconPillButton, {
  IAppIconPillButtonProps,
} from '../app-icon-pill-button/AppIconPillButton';

export function AppAiPillButton({
  colorVariant = 'secondary',
  ...props
}: IAppIconPillButtonProps) {
  return (
    <AppIconPillButton colorVariant={colorVariant} {...props}>
      <AiIcon />
    </AppIconPillButton>
  );
}

export default AppAiPillButton;
